import { render, staticRenderFns } from "./foot2.vue?vue&type=template&id=06bc7cef&scoped=true&"
import script from "./foot2.vue?vue&type=script&lang=js&"
export * from "./foot2.vue?vue&type=script&lang=js&"
import style0 from "./foot2.vue?vue&type=style&index=0&id=06bc7cef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bc7cef",
  null
  
)

export default component.exports